export const spanish = {
  welcomeToSoloPlat: "¡Bienvenido(a) a Sologenic!",
  alreadyHaveAccount: "Ya tengo una cuenta en CoinField",
  withoutAccount: "Aún no tengo cuenta",
  signIn: "Entrar",
  searchLabel: "Buscar",
  searchAdvLabel: "Avanzado",
  balance: "Saldo",
  selectOne: "Seleccione uno",
  selectLanguage: "Seleccione Idioma",
  theme: "Tema",
  summary: "Resumen",
  optAllRegions: "Todas las regiones",
  optAsia: "Asia",
  optEuro: "Europa",
  optOceania: "Oceania",
  optNorth: "Norteamérica",
  optSouth: "Sudamérica",
  optUSA: "E.U.A",
  allExchanges: "Todas las Bolsas",
  cancel: "Cancelar",
  continue: "Continuar",
  confirmTrade: "Confirmar Transacción",
  buyWith: "Comprar con",
  sellFor: "Vender por",
  signInCopy:
    "CoinField is an exchange platform copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy copy",
  signUp: "Registrarse",
  signUpCopy:
    "Con esta cuenta tendras acceso a la plataforma de CoinField y a la plataform de Sologenic con las mismas credenciales",

  loginCopy: "Entra usando tus credenciales de CoinField",
  usernamePlaceholder: "Correo Electrónico",
  passwordPlaceholder: "Contraseña",
  otpPlaceholder: "Ingresa tu 2FA (si activo)",
  forgotPassword: "¿Olvidaste tu contraseña?",
  noAccount: "¿No tienes cuenta?",
  menuTrade: "Plataforma",
  menuPortfolio: "Cartera",
  menuSettings: "Ajustes",
  menuDex: "DEX",
  menuOrders: "Órdenes",
  menuSupport: "Soporte",
  menuHistory: "Historial",
  stocksPopular: "Populares",
  stocksFavorite: "Favoritos",
  stocksRecent: "Recientes",
  stocksGain: "Mayor Ganancia",
  stocksLoss: "Mayor Pérdida",
  stocksLocation: "Ubicación",
  stocksTableMarket: "Mercado",
  stocksTableExchange: "Bolsa",
  stocksTableCurrency: "Divisa",
  stocksTableChange: "Cambio (24h)",
  stocksTableBuy: "Precio de Compra",
  stocksTableSell: "Precio de Venta",
  stockSearchPH: "Buscar por símbolo",
  singleStockOpen: "ABIERTO",
  singleStockOpensIn: "Abre en:",
  searchComponentPlaceholder: "Buscar por Acción, ETF, Producto… Símbolo",
  exchangeCatAll: "Todas",
  exchangeCatStocks: "Acciones",
  exchangeCatEtf: "ETFs",
  exchangeCatComm: "Productos",
  exchangeCatCfd: "CFD",
  exchangeCatFx: "Forex",
  exchangeCatAllTypes: "Todos los tipos",
  allExchanges: "Todas las bolsas",
  buy: "Comprar",
  sell: "Vender",
  browseByExchange: "Busca por Bolsa",
  expand: "Expandir",
  collapse: "Colapsar",
  searchTickerSymbol: "Buscar símbolo",
  filterRegions: "Filtrar Region",
  filterExchange: "Filtrar Bolsa",
  filterAsset: "Filtrar Activo",
  filterOpen: "Filtrar Abiertas",
  lastPrice: "Último precio",
  change: "Cambio",
  bidSize: "Bid/Size",
  askSize: "Ask/Size",
  high: "Alto",
  low: "Bajo",
  volume: "Volumen",
  conversionByCF: "La conversión de tus criptos estan siendo procesada por ",
  tradeOptMarket: "Mercado",
  tradeOptLimit: "Límite",
  tradeOptStopLimit: "Stop-Limit",
  tradeOptStop: "Stop",
  amountTo: "Cantidad a",
  enterAmount: "Ingresa cantidad",
  timeInForce: "Time in Force Policy",
  limitPrice: "Precio límite",
  stopPrice: "Precio Stop",
  tradeDisclaimer:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
};
